// utils/syncOfflineForms.js
import axios from "axios";
import { env } from "../constants/env";
import { db } from "./offlineDB";

// Update utils/syncOfflineForms.js
export const syncOfflineForms = async () => {
  if (!navigator.onLine) return;

  const allForms = await db.questionnaires.toArray();

  console.log("CHECKING ALL FORMS", allForms)

  for (const form of allForms) {
    const { offline, timestamp, lastSynced, labId, formType, answers } = form;

    const localIsNewer =
      !lastSynced || new Date(timestamp) > new Date(lastSynced);

    if (!offline && !localIsNewer) continue; // nothing to sync

    try {
      // same payload cleanup
      const payload = {
        labId,
        formType,
        answers,
        timestamp,
        syncedAt: new Date().toISOString(),
      };

      const res = await axios.post(
        `${env.kataApiUrl}/api/questionnaire/${formType}`,
        payload
      );

      // Update DB flags
      await db.questionnaires
        .where("[labId+formType]")
        .equals([labId, formType])
        .modify({
          offline: false,
          lastSynced: new Date().toISOString(),
          ...res.data.data,
        });

      console.log(`[SYNC] Sent ${formType}/${labId}`);
    } catch (err) {
      console.error(`[SYNC] Failed:`, err.message);
    }
  }
};